import * as Yup from 'yup'
import { NAME } from './fields'

export const validationSchema = Yup.object({
  [NAME]: Yup.string().required('Name required').max(255, 'Name should have maximum 255 characters')
})
